import React from 'react';

const Circle = ({ percentage }) => {

  const roundedInteger = Math.round(percentage)

  
  const radius = 40; // Radius of the circle
  const circumference = 2 * Math.PI * radius; // Circumference of the circle

  // Calculate the strokeDashoffset based on the percentage
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="transparent"
        stroke="#cf166f" // Orange color
        strokeWidth="10" // Stroke width
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dy=".3em"
        fontSize="16"
        fill="#000" // Text color
      >
        {roundedInteger}%
      </text>
    </svg>
  );
};

export default Circle;